import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import HoroscopeDetail from './components/HoroscopeDetail';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/horoscope/:sign" element={<HoroscopeDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
